import {
    ClickAwayListener,
    Grid,
    Grow,
    InputAdornment,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Typography
} from '@material-ui/core'
import Utils from 'EurestoFonction/Utils'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import Input from './Input'


export default React.memo(props => {

    const [value, setValue] = useState(((props.options || []).find(o => o.value === props.data) || {}).label
        || (props.add ? props.value : props.data)
        || '')

    const customLabel = useRef(undefined)

    useEffect(() => {
        console.log('5')
        const option = ((props.options || []).find(o => o.value === props.data) || {})
        customLabel.current = option.customLabel
        const val = option.label
            || (props.add ? props.value : props.data)
            || ''

        setValue(val)
        if (val !== value) {
            setKeyInput(Utils.getRandomNumber())
        }
    }, [props.options])

    const [anchorEl, setAnchorEl] = useState(null)

    const [keyInput, setKeyInput] = useState(Utils.getRandomNumber())

    const [highLightedRow, setHighLightedRow] = useState(undefined)
    const [open, setOpen] = useState(false)

    const key = useMemo(() => Utils.uuidv4(), [])

    const menuListHeight = useMemo(() => (props.options || []).length * 28 < 150 ? (props.options || []).length * 28 : (props.menuMaxHeight || 150), [(props.options || []).length, props.menuMaxHeight])

    const scrollToLabel = (highLightedRow) => {
        if (highLightedRow >= 0) {
            let li = document.getElementById('menu-item-' + highLightedRow)
            if (li) {
                var ul = li.parentNode
                // fudge adjustment for borders effect on offsetHeight
                var fudge = 4
                ul.scrollTop = li.offsetTop - fudge
            }
        }
    }

    const onChangeInput = (data) => {
        console.log('1', data)
        const hlR = (props.options || []).findIndex(o => o.label && o.label.toUpperCase && o.label.insensitiveCaseAccents().startsWith((data).insensitiveCaseAccents())) || highLightedRow || 0
        setHighLightedRow(hlR)
        setValue(data || '')
        customLabel.current = undefined
        setOpen(true)
        props.onChangeText && props.onChangeText(data || '', props.nameText || props.name)
    }

    const handleClose = e => {
        console.log('2')
        let val = ''
        if (props.add) {
            val = value || ''
        } else if (!value) {
            val = ''
        } else if (props.data !== undefined) {
            const option = ((props.options || []).find(o => o.value === props.data) || {})
            customLabel.current = option.customLabel
            val = option.label || ''
        }
        setOpen(false)
        setValue(val)
        props.add && props.onChangeText && props.onChangeText(val, props.nameText || props.name)
        !value && props.onChange && props.onChange(undefined, props.name)
    }

    const handleClickMenu = (val, name) => e => {
        const option = ((props.options || []).find(o => o.value === val) || {})
        console.log('3')
        if (val === props.data) {
            val = undefined
            name = ''
        }
        setOpen(false)
        setValue(name)
        customLabel.current = option.customLabel
        setKeyInput(Utils.getRandomNumber())
        props.onChange && props.onChange(val, props.name)
    }

    useEffect(() => {
        scrollToLabel(highLightedRow)
    }, [highLightedRow])

    const menuHandleKeyDown = event => {
        const options = (props.options || [])
        const hlR = highLightedRow || 0
        if (options.length > 0 && hlR >= 0) {
            switch (event.key) {
                case 'Enter':
                    const option = options[hlR]
                    if (option.onClick) {
                        menuItemClicked(option.onClick, option.value, option.label, option.resetOnClicked)()
                    } else {
                        handleClickMenu(option.value, option.label)()
                    }
                    break
                case 'ArrowUp':
                    if (hlR !== -1 && hlR > 0) {
                        setHighLightedRow(hlR - 1)
                    }
                    break
                case 'ArrowDown':
                    if (hlR !== -1 && hlR < options.length - 1) {
                        setHighLightedRow(hlR + 1)
                    }
                    break
            }
        }
    }

    const menuItemClicked = (cb, data, label, reset) => _ => {
        console.log('4')
        cb(data, label, value)()
        if (reset) {
            setOpen(false)
            setValue('')
            setKeyInput(Utils.getRandomNumber())
        }
    }

    const optionStyle = props.options && props.options.find(o => o.value === props.data) && props.options.find(o => o.value === props.data).style || {}

    const startAdorment = props.options && props.options.find(o => o.value === props.data) && props.options.find(o => o.value === props.data).startAdornment || {}

    return (
        <div style={Object.assign({
            position: 'relative',
            width: '100%',
            margin: 0,
            padding: 0,
            //paddingBottom: 5
        }, props.style || {})}>
            <Input
                handleOnClick={props.handleOnClick}
                autocomplete={props.autocomplete}
                placeholder={props.placeholder}
                key={keyInput}
                classes={props.classes}
                variant={props.variant}
                inlineWidth={props.inlineWidth}
                inputRef={node => {
                    setAnchorEl(node)
                }}
                style={{
                    paddingBottom: 0,
                    ...(props.inputStyle || {}),
                    ...optionStyle
                }}
                className={(props.className || '') + (!props.disabled && 'cursor-pointer' || 'cursor-not-allowed')}
                inline={props.inline}
                autoFocus={props.autoFocus}
                title={props.title}
                value={value && !Array.isArray(value) && value}
                fullWidth
                disabled={props.disabled || !(props.autoComplete !== false)}
                onChange={onChangeInput}
                aria-owns={'menu-list-grow' + key}
                aria-haspopup="true"
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    !props.disabled && onChangeInput(value, '', e)
                }}
                inputProps={props.inputProps || {}}
                onKeyDown={menuHandleKeyDown}
                InputProps={{
                    ...Object.assign({
                        className: props.selectedTextClassName || '',
                        endAdornment: <InputAdornment position="end"><i
                            style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: 7, zIndex: 1 }}
                            className={'ei-commun_chevron ei-down'} /></InputAdornment>
                    }, startAdorment && Object.keys(startAdorment).length > 0 &&
                    { startAdornment: <div style={{ zIndex: 2, marginRight: 2 }}>{startAdorment}</div> }
                    || {}),
                    ...(props.InputProps || {})
                }}>
            </Input>
            {
                customLabel.current && <Grid container justify={"center"} alignContent={"center"} alignItems={"center"} style={{ padding: 0, margin: 0, left: 2.5, top: 3, backgroundColor: 'white', width: 'calc(100% - 20px)', height: 'calc(100% - 5px)', position: 'absolute', zIndex: 5 }}>{customLabel.current}</Grid>
            }
            {(!props.add || props.data !== -1) &&
                <Popper anchorEl={anchorEl || null} style={{ zIndex: 400 }}
                    className={props.classNameModal}
                    open={open || false} transition
                    disablePortal>
                    {({ TransitionProps, placement }) => (
                        <ClickAwayListener onClickAway={handleClose}>
                            <Grow
                                {...TransitionProps}
                                id={'menu-list-grow' + key}
                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom', }}>
                                <Paper style={{
                                    resize: 'both',
                                    overflow: 'auto',
                                    position: 'relative',
                                    height: menuListHeight + (props.add && 28 || 0),
                                    width: $(anchorEl).parent().css('width'),
                                    ...(props.MenuProps && props.MenuProps.style || {})
                                }}>
                                    {
                                        props.loading &&
                                        <MenuList
                                            id={'popper-' + key} style={{
                                                width: 100,
                                                height: '100%',
                                                //zIndex: 400,
                                                overflowY: 'auto',
                                                position: 'absolute',
                                            }}>
                                            <MenuItem>Loading...</MenuItem>
                                        </MenuList>
                                        ||
                                        <MenuList
                                            id={'popper-' + key} style={{
                                                width: '100%',
                                                height: '100%',
                                                //zIndex: 400,
                                                overflowY: 'auto',
                                                position: 'absolute',
                                            }}>
                                            {
                                                props.add &&
                                                <MenuItem
                                                    onClick={handleClickMenu(-1, value)}><i
                                                        className={'ei-commun_ajouter'} /><Typography
                                                            noWrap
                                                            style={{ marginLeft: 2 }}>Ajouter...</Typography></MenuItem>
                                            }
                                            {
                                                (props.options || []).map((o, i) =>
                                                    <MenuItem
                                                        disabled={o.disabled} selected={o.value === props.data}
                                                        key={key + '_' + i + '_' + o.value + '_' + (highLightedRow === i)}
                                                        style={{
                                                            ...(o.style || {}),
                                                            background: highLightedRow === i && o.value !== props.data && '#F1F1F1' || ''
                                                        }}
                                                        id={'menu-item-' + i}
                                                        {...o}
                                                        onClick={o.onClick ? menuItemClicked(o.onClick, o.value, o.label, o.resetOnClicked) : handleClickMenu(o.value, o.label)}>
                                                        {o.startAdornment || ''}
                                                        <Typography noWrap
                                                            style={{ marginLeft: 2 }}>{o.html || o.label}</Typography></MenuItem>)
                                            }
                                        </MenuList>}
                                </Paper>
                            </Grow>
                        </ClickAwayListener>
                    )}
                </Popper>}
        </div>
    )
})



// WEBPACK FOOTER //
// ./app/Components/AutoComplete.js